<script>
  import { getContext } from "svelte";
  import AboutModalContent from "./AboutModalContent.svelte";

  const { open } = getContext("simple-modal");

  const showModal = () => {
    open(
      AboutModalContent,
      {},
      { styleBg: { top: 0, left: 0, "z-index": 1001 } }
    );
  };
</script>

<button on:click={showModal} title="About">About</button>

<style>
  button {
    text-decoration: underline;
    background: none;
    margin: 0;
    padding: 0;
    border: none;
    cursor: pointer;
    border-color: transparent;
    outline: none;
  }
</style>
